import { createContext } from 'react';

const opdContext = createContext();

export default opdContext;
